import { API } from "../api/axios";
const END_POINT_STUDENT = "/student-situation";
const END_POINT_PARENT = "/parent-situation";

class SituationsService {
    getStudentSituation() {
        return API.get(END_POINT_STUDENT);
    }
    getParentSituation() {
        return API.get(END_POINT_PARENT);
    }
}

export default new SituationsService();
